import { Controller, useFormContext } from 'react-hook-form'

import { Box, Divider, Text, useToggle } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Input, Textarea } from '@factorialco/f0-react/dist/experimental'
import { ChevronDown, ChevronRight } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import { NodeSidepanelSchema } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'

type Props = {
  title: string
  description: string
  onTitleChange?: (value: string) => void
  onDescriptionChange?: (value: string) => void
  titleLabel?: string
  titlePlaceholder?: string
  descriptionLabel?: string
  descriptionPlaceholder?: string
  readonly?: boolean
  hideDivider?: boolean
  useReactHookForm?: boolean
  defaultCollapsed?: boolean
}

export const BasicInputs = ({
  title,
  description,
  onTitleChange,
  onDescriptionChange,
  titleLabel = i18n.t('workflows.sidepanel.condition.block_title'),
  titlePlaceholder = i18n.t('workflows.sidepanel.condition.block_title'),
  descriptionLabel = i18n.t('workflows.sidepanel.condition.block_description'),
  descriptionPlaceholder = i18n.t('workflows.sidepanel.condition.block_description'),
  readonly = false,
  hideDivider = false,
  useReactHookForm = false,
  defaultCollapsed = true,
}: Props) => {
  const [open, toggle] = useToggle(!defaultCollapsed)
  const { control } = useFormContext<NodeSidepanelSchema>()

  return (
    <Box gap="s8">
      <Box
        flexDirection="row"
        alignItems="center"
        width="full"
        cursor="pointer"
        onClick={toggle(!open)}
      >
        <Box flexDirection="row" gap="s8" alignItems="center">
          <Text color="textPrimary" size="300" weight="medium">
            {i18n.t('workflows.sidepanel.trigger.block_header')}
          </Text>
          <F0Icon icon={open ? ChevronDown : ChevronRight} size="md" />
        </Box>
      </Box>
      <Box
        gap="s16"
        style={{
          overflow: 'hidden',
          transition: 'max-height 150ms ease-in-out, opacity 150ms ease-in-out',
          maxHeight: open ? '800px' : '0px',
          opacity: open ? '1' : '0',
        }}
      >
        {useReactHookForm ? (
          <Controller
            name="title"
            control={control}
            render={({ field, fieldState }) => (
              <Input
                size="md"
                label={titleLabel}
                placeholder={titlePlaceholder}
                value={field.value}
                onChange={field.onChange}
                disabled={readonly}
                error={fieldState.error?.message}
              />
            )}
          />
        ) : (
          <Input
            size="md"
            label={titleLabel}
            placeholder={titlePlaceholder}
            value={title}
            onChange={onTitleChange}
            disabled={readonly}
          />
        )}

        {/* Textarea disabled option not working */}
        {useReactHookForm ? (
          <Controller
            name="description"
            control={control}
            render={({ field, fieldState }) => (
              <Textarea
                label={descriptionLabel}
                placeholder={descriptionPlaceholder}
                value={field.value}
                onChange={field.onChange}
                disabled={readonly}
                error={fieldState.error?.message}
              />
            )}
          />
        ) : (
          <Textarea
            label={descriptionLabel}
            placeholder={descriptionPlaceholder}
            value={description}
            onChange={onDescriptionChange}
            disabled={readonly}
          />
        )}
        {!hideDivider && <Divider />}
      </Box>
    </Box>
  )
}
